import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanLoad, Router, RouterStateSnapshot } from '@angular/router';
// tslint:disable-next-line: import-blacklist
import { Observable } from 'rxjs';
import { AuthInterceptor } from '../../interceptor/auth.interceptor';



@Injectable()
export class AuthGuard implements CanLoad {

  url: string;

  constructor(
    private router: Router,
    private authInterceptor: AuthInterceptor
  ) { }


  // permissão de carregar o component
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {

  //   console.log('route ', route);
  //   console.log('state ', state);
  //   setTimeout(()=>{
  //   this.liberarAcesso(state['url'])
  // }, 1000);
    return this.verificarAcesso()
  }


  // permissão de carregar o modulo
  canLoad(
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.verificarAcesso();
  }

  // private liberarAcesso(url) {
  //   console.log('url ', url);

  //   if (url !== null) {

  //     if (url  ===  '/home') {
  //       GerencimentoPermissoesUtil.gerenciarPermissoes('INÍCIO');
  //     }
  //     if (url  ===  '/loginIndependente') {
  //       GerencimentoPermissoesUtil.gerenciarPermissoes('');
  //     }
  //     if (url  ===  '/faq') {
  //       GerencimentoPermissoesUtil.gerenciarPermissoes('');
  //     }
  //   }
  // }


  private verificarAcesso() {

    if (!this.authInterceptor.tokenInvalid()) {
      return true;
    }


    this.router.navigate(['/login']);
    return false;
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/routes/guards/auth.guard.ts